import { signIn } from "../../api/services/auth";
import {
  CLIENT_CREDETIONAL_GRANT_TYPE,
  PASSWORD_GRANT_TYPE,
  REFRESH_TOKEN_GRANT_TYPE,
} from "../../api/services/auth/constants";
import { ILoginResponse } from "../../api/services/auth/models";
import { AppLogin, contextUserLogin } from "../authContext";
import { AuthConfig } from "../config/authConfig";

export const setAppToken = async () => {
  const credentials = new FormData();
  credentials.append("grant_type", CLIENT_CREDETIONAL_GRANT_TYPE);
  try {
    const res: ILoginResponse = await signIn(credentials);
    AppLogin(res);
  } catch (err) {
    console.log(err);
  }
};
export const loginUser = (credentials: FormData) => {
  credentials.append("grant_type", PASSWORD_GRANT_TYPE);
  return signIn(credentials);
};
export const setRefreshToken = async () => {
  const credentials = new FormData();
  credentials.append("grant_type", REFRESH_TOKEN_GRANT_TYPE);
  credentials.append("refresh_token", AuthConfig.getRefreshToken() || "");
  try {
    const res: ILoginResponse = await signIn(credentials);
    contextUserLogin(res);
  } catch (err) {
    console.log(err);
  }
};
